function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "google_drive_a",
  d: "M77.301 32.74H40.015V48.2h21.462c-2 9.821-10.367 15.46-21.462 15.46A23.598 23.598 0 0 1 16.37 40.015 23.598 23.598 0 0 1 40.015 16.37c5.638 0 10.73 2 14.732 5.274l11.64-11.64C59.295 3.82 50.2 0 40.016 0A39.9 39.9 0 0 0 0 40.015a39.9 39.9 0 0 0 40.015 40.014c20.007 0 38.195-14.55 38.195-40.014 0-2.365-.363-4.911-.909-7.276z"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_drive_c",
  d: "M77.301 32.74H40.015V48.2h21.462c-2 9.821-10.367 15.46-21.462 15.46A23.598 23.598 0 0 1 16.37 40.015 23.598 23.598 0 0 1 40.015 16.37c5.638 0 10.73 2 14.732 5.274l11.64-11.64C59.295 3.82 50.2 0 40.016 0A39.9 39.9 0 0 0 0 40.015a39.9 39.9 0 0 0 40.015 40.014c20.007 0 38.195-14.55 38.195-40.014 0-2.365-.363-4.911-.909-7.276z"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_drive_e",
  d: "M77.301 32.74H40.015V48.2h21.462c-2 9.821-10.367 15.46-21.462 15.46A23.598 23.598 0 0 1 16.37 40.015 23.598 23.598 0 0 1 40.015 16.37c5.638 0 10.73 2 14.732 5.274l11.64-11.64C59.295 3.82 50.2 0 40.016 0A39.9 39.9 0 0 0 0 40.015a39.9 39.9 0 0 0 40.015 40.014c20.007 0 38.195-14.55 38.195-40.014 0-2.365-.363-4.911-.909-7.276z"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_drive_g",
  d: "M77.301 32.74H40.015V48.2h21.462c-2 9.821-10.367 15.46-21.462 15.46A23.598 23.598 0 0 1 16.37 40.015 23.598 23.598 0 0 1 40.015 16.37c5.638 0 10.73 2 14.732 5.274l11.64-11.64C59.295 3.82 50.2 0 40.016 0A39.9 39.9 0 0 0 0 40.015a39.9 39.9 0 0 0 40.015 40.014c20.007 0 38.195-14.55 38.195-40.014 0-2.365-.363-4.911-.909-7.276z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "google_drive_b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_drive_a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  fillRule: "nonzero",
  mask: "url(#google_drive_b)",
  d: "M-3.638 63.66V16.37l30.921 23.645z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_drive_d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_drive_c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  fillRule: "nonzero",
  mask: "url(#google_drive_d)",
  d: "M-3.638 16.37l30.921 23.645L40.015 28.92l43.652-7.094V-3.638H-3.638z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_drive_f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_drive_e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  fillRule: "nonzero",
  mask: "url(#google_drive_f)",
  d: "M-3.638 63.66l54.566-41.834 14.369 1.819 18.37-27.283v87.305H-3.638z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_drive_h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_drive_g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  fillRule: "nonzero",
  mask: "url(#google_drive_h)",
  d: "M83.667 83.667L27.283 40.015l-7.276-5.457 63.66-18.188z"
}));

var SvgGoogleDriveIco = function SvgGoogleDriveIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleDriveIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_drive_ico.ca785755.svg";
export { ForwardRef as ReactComponent };